/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandAppleNews = createReactComponent("outline", "brand-apple-news", "IconBrandAppleNews", [["path", { "d": "M4 14l6 6h-6z", "key": "svg-0" }], ["path", { "d": "M20 10l-6 -6h6z", "key": "svg-1" }], ["path", { "d": "M4 4v4l12 12h4v-4l-12 -12z", "key": "svg-2" }]]);

export { IconBrandAppleNews as default };
//# sourceMappingURL=IconBrandAppleNews.mjs.map
